var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1970_1673)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1970_1673",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.711914H0V14.2877H28V0.711914Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1970_1673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4262 11.5786C27.612 11.3977 27.7296 11.1442 27.7296 10.8615C27.7296 10.5893 27.6026 10.3446 27.4289 10.1654L19.5994 2.17131L17.2365 4.5844L23.4004 10.8778H14.6672C14.2403 10.8649 13.9022 10.7186 13.6159 10.4352L9.69699 6.43444C9.27479 6.02513 8.71411 5.7958 8.13044 5.79366L8.12477 5.794H3.34224V4.12418H8.29513C9.27674 4.12486 10.1524 4.53485 10.7942 5.19327L13.7171 8.17755L16.0801 5.76447L13.1001 2.72248C11.8552 1.47012 10.1731 0.711914 8.28711 0.711914H0V9.20593H7.00859C7.22572 9.20737 7.44049 9.2531 7.64037 9.33931C7.84025 9.42551 8.02136 9.55117 8.1732 9.70891L12.0106 13.6269C12.4122 14.0309 12.9487 14.2669 13.5136 14.2877H24.1154C24.5453 14.2822 24.956 14.1055 25.259 13.7956L27.4275 11.5813L27.4262 11.5786Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1970_1673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 13.5758,
    fill: "white",
    transform: "translate(0 0.711914)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaIcon);
export default __webpack_public_path__ + "static/media/ra-icon.32f1d865b2fd23ead0634d842879b978.svg";
export { ForwardRef as ReactComponent };